import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataYy from './phonics/phonics_data_yy';

function PhonicsYy() {
  return <PhonicsAtoZ letterData={letterDataYy} />;
}

export default PhonicsYy;
